import { API_BASE_URL } from '../config';

export interface Company {
  id: string;
  name: string;
  company_type: string;
  description: string | null;
  city: string | null;
  country: string | null;
  website: string | null;
  logo_url: string | null;
  is_verified: boolean;
  employee_count: string | null;
  founded_year: number | null;
}

export interface Connection {
  id: string;
  company_id: string;
  company_name: string;
  company_type: string;
  city: string | null;
  country: string | null;
  logo_url: string | null;
  is_verified: boolean;
  status: string;
  connected_at: string | null;
}

function authHeaders(token: string) {
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

export async function fetchCompanies(token: string, params: { city?: string; country?: string; type?: string } = {}): Promise<Company[]> {
  const q = new URLSearchParams();
  if (params.city) q.set('city', params.city);
  if (params.country) q.set('country', params.country);
  if (params.type) q.set('company_type', params.type);
  const res = await fetch(`${API_BASE_URL}/api/v1/companies?${q}`, { headers: authHeaders(token) });
  if (!res.ok) return [];
  const data = await res.json();
  return data.items ?? data ?? [];
}

export async function fetchMyCompany(token: string): Promise<Company | null> {
  const res = await fetch(`${API_BASE_URL}/api/v1/companies/my`, { headers: authHeaders(token) });
  if (!res.ok) return null;
  return res.json();
}

export async function fetchConnections(token: string): Promise<Connection[]> {
  const res = await fetch(`${API_BASE_URL}/api/v1/network/connections`, { headers: authHeaders(token) });
  if (!res.ok) return [];
  return res.json();
}

export async function connectToCompany(token: string, companyId: string): Promise<Connection | null> {
  const res = await fetch(`${API_BASE_URL}/api/v1/network/connections`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify({ company_id: companyId }),
  });
  if (!res.ok) return null;
  return res.json();
}

export async function disconnectFromCompany(token: string, companyId: string): Promise<boolean> {
  const res = await fetch(`${API_BASE_URL}/api/v1/network/connections/${companyId}`, {
    method: 'DELETE',
    headers: authHeaders(token),
  });
  return res.ok;
}
